import type { LocalDto, Role } from '@gl/shared';
import { createContext, useContext } from 'react';

/**
 * Local actual dentro del shell `/l/:localId/*`. El AppShell solo renderiza las páginas
 * cuando el local ya cargó, así que `useCurrentLocal()` siempre devuelve un LocalDto.
 */
export const LocalContext = createContext<LocalDto | null>(null);

export function useCurrentLocal(): LocalDto {
  const local = useContext(LocalContext);
  if (!local) throw new Error('useCurrentLocal tiene que usarse dentro de /l/:localId');
  return local;
}

/** `can('OWNER', 'MANAGER')` → true si el rol actual está en la lista. */
export function useHasRole(...roles: Role[]): boolean {
  const local = useCurrentLocal();
  return roles.includes(local.role);
}
